export class UserHealthRecord {
  userHealthRecordId?: number;
  userId: string;
  testType: number;
  weight?: number;
  height?: number;
  comments: string;
  testDate: Date;
  incidentName: string;
  temperature: number;
  pulse: number;
  sufferingFrom: string;
  bloodPressure: number;
  bloodSugar: number;
  diagnosis: string;
  returnClassImmediately: boolean = false;
  leaveSchool: boolean = false;
  nextVisit?: Date;
  sendToStudent: boolean = false;
  sendToParents: boolean = false;
  sendViaEmail: boolean = false;
  sendViaSms: boolean = false;
}
